/* eslint-disable react/no-unused-prop-types */
import { Tabs } from '@pmi/dsm-react';
import { Label } from '@pmi/dsm-react/dist/components/tabs/Tabs';
import { useMemo } from 'react';

interface ReportTypeTabProps {
  reportType: string;
  onTabChange: (value: string) => void;
  startDate: string | any;
  endDate: string | any;
  // eslint-disable-next-line react/require-default-props
  tabChange?: () => void;
}

export default function ReportTypeTab({
  reportType,
  onTabChange,
  startDate,
  endDate,
  tabChange,
}: ReportTypeTabProps) {
  const tabLabels = useMemo(() => {
    const tabs: Label[] = [
      { label: 'All Time', value: 'All Time' },
      { label: 'This Month', value: 'This Month' },
      { label: 'Previous Month', value: 'Previous Month' },
      {
        label: `Custom Date Range${
          startDate && endDate ? `: ${startDate} - ${endDate}` : ''
        }`,
        value: `Custom Date Range${
          startDate && endDate ? `: ${startDate} - ${endDate}` : ''
        }`,
      },
    ];
    if (reportType === 'Custom Date Range' && startDate && endDate) {
      tabs[3] = {
        label: `Custom Date Range: ${startDate} - ${endDate}`,
        value: `Custom Date Range: ${startDate} - ${endDate}`,
      };
    }

    return tabs;
  }, [reportType, startDate, endDate]);

  return (
    <Tabs
      theme="light"
      labels={tabLabels}
      size="sm"
      onChange={(evt, value) => {
        const data = tabLabels[value];
        onTabChange(data.value);
        if (tabChange) tabChange();
      }}
      value={tabLabels.findIndex((x) => x.value === reportType)}
    />
  );
}
